import { FC, HTMLAttributes, ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { FiExternalLink } from 'react-icons/fi';
import { Typography } from 'antd';
import styleCss from './index.module.less';

const { Text } = Typography;

interface LinkExternalIconProps extends HTMLAttributes<HTMLSpanElement> {
  to: string;
  responsiveListing?: boolean;
  children?: ReactNode;
  style?: React.CSSProperties;
}

const LinkExternalIcon: FC<LinkExternalIconProps> = ({ to, children, style = {}, responsiveListing = false, ...props }) => {
  return (
    <div className={styleCss.linkContainer} style={style} {...props}>
      <Text className={responsiveListing ? styleCss.linkText : ''} ellipsis={responsiveListing}>
        {children}
      </Text>

      <Link to={to} style={{ display: 'inline-flex', alignItems: 'center' }}>
        <FiExternalLink />
      </Link>
    </div>
  );
};

export default LinkExternalIcon;
